import { createContext, useContext, type ReactNode } from 'react';

/**
 * Tiny context exposing the wizard session ID to every page underneath
 * `RegistrationLayout`. Avoids prop-drilling through 6+ steps. The
 * provider is mounted once in the layout; consumers call
 * `useWizardSessionIdContext()` and pass the value to BE clients.
 *
 * Returns empty string when used outside the provider — consumers
 * treat that as "no session" and skip the field. This keeps unit
 * tests / Storybook scenarios trivially renderable.
 */
const WizardSessionIdContext = createContext<string>('');

export function WizardSessionIdProvider({
  value,
  children,
}: {
  value: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <WizardSessionIdContext.Provider value={value}>
      {children}
    </WizardSessionIdContext.Provider>
  );
}

export function useWizardSessionIdContext(): string {
  return useContext(WizardSessionIdContext);
}
